import React from 'react';
import { Autocomplete, Box, TextField, Typography } from '@mui/material';
import { SavedChartOption } from '../../utils/savedChartOptions';
import { formatDisplayDate } from '../../utils/dateDisplay';

export default function SavedChartAutocomplete({ charts, value, onChange }: {
  charts: SavedChartOption[];
  value: SavedChartOption;
  onChange: (chart: SavedChartOption) => void;
}) {
  return <Autocomplete
    size="small"
    disableClearable
    options={charts}
    value={value}
    getOptionLabel={chart => chart.birthDetails?.name || 'Saved chart'}
    isOptionEqualToValue={(option, selected) => option._id === selected._id}
    onChange={(_event, chart) => chart && onChange(chart)}
    noOptionsText="No saved charts match this name"
    renderInput={params => <TextField {...params} label="Base chart" placeholder="Search saved charts by name" />}
    renderOption={(props, chart) => {
      const { key: _key, ...optionProps } = props as typeof props & { key?: React.Key };
      const birth = chart.birthDetails;
      const details = [formatDisplayDate(birth?.dateOfBirth), birth?.timeOfBirth, birth?.placeOfBirth?.name].filter(Boolean).join(' · ');
      return <Box component="li" {...optionProps} key={chart._id} sx={{ display: 'block !important' }}>
        <Typography variant="body2">{birth?.name || 'Saved chart'}</Typography>
        <Typography variant="caption" color="text.secondary" sx={{ display: 'block' }}>
          {details ? `${details} · ` : ''}ID: {chart._id.slice(-8)}
        </Typography>
      </Box>;
    }}
    sx={{ minWidth: 0, '& .MuiInputBase-root': { bgcolor: 'background.paper' } }}
  />;
}
